import React, { FC, useState } from 'react'
import classnames from 'classnames'
import { Balloon, BalloonProps } from './Balloon'
import { useOutsideClick } from '../../../hooks/useOutsideClick'

// @ts-ignore
import styles from './Hint.scss'


// @ts-ignore
import { Question } from '../../../icons'

export type HintProps = JSX.IntrinsicElements['div'] & BalloonProps & {
  iconSize?: number
}

export const Hint: FC<HintProps> = ({
  iconSize = 16,
  width,
  leftPoint,
  children,
  className,
  ...props
}) => {
  const balloonProps = { width, leftPoint, children }
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const hintRef = useOutsideClick<HTMLDivElement>(() => setIsOpen(false))

  const handleClick = (e: MouseEvent) => {
    setIsOpen(!isOpen)
    e.stopPropagation()
  }

  return (
    <div
      ref={hintRef}
      className={classnames(styles.container, className)}
      {...props}
    >
      <Question
        size={iconSize}
        onClick={handleClick}
        className={styles.icon}
      />
      {isOpen && <Balloon {...balloonProps} /> }
    </div>
  )
}
